import createVueApp from '@/common/create_app'

Styxie.Initializers.Onboarding = {
  show: async(props) => {
    const { default: OnboardingWizard } = await import('@/vue_widgets/local_optics/onboarding/OnboardingWizard.vue')
    createVueApp(OnboardingWizard, { props })
  }
}
